import React from 'react';
import { NextPage } from 'next';
import Layout from '../../components/layout';
import ContactUsContainer from '../../components/contact-us-container';
import GenericContainer from '../../components/@container/generic-container';

const ContactUsPage: NextPage = () => (
  <Layout title="Contact Us">
    <GenericContainer
      title="Contact Us"
      breadcrumb={{ url: '/', text: 'Back to Home' }}
    >
      <div className="content">
        <ContactUsContainer />
      </div>
    </GenericContainer>
  </Layout>
);

export default ContactUsPage;
